import type { Brand } from '@/types/constants';
import { getConfig } from '@/utils/config/config';
import { COOKIES, getCookieValue } from '@/utils/cookies';
import { buildApiUrl, buildUrl } from '@/utils/url/build-url';
import { fetchApi } from './fetcher';

enum CustomerDataActions {
    ENTRY = 'entry'
}

const getHeaders = async () => {
    const region = await getCookieValue(COOKIES.REGION);
    const brand = process.env.BRAND as Brand;
    const authToken = await getCookieValue(COOKIES.AUTH_TOKEN);
    const loginToken = await getCookieValue(COOKIES.LOGIN_TOKEN);

    const headers: Record<string, string> = {
        'x-region-code': region,
        'x-brand': brand
    };

    if (authToken && loginToken) {
        headers['X-Auth-Token'] = authToken;
        headers['X-Login-Token'] = loginToken;
    }

    return headers;
};

const getCustomerDataBaseUrl = () => {
    const config = getConfig();

    return buildApiUrl(config.apis.CustomerDataClient);
};

export const customerData = async (action: CustomerDataActions, params: Record<string, string>) => {
    const config = getConfig();
    const baseUrl = getCustomerDataBaseUrl();
    const headers = await getHeaders();

    // TODO & at the end of the params in the url... check
    const url = buildUrl(`${baseUrl}/${action}`, {
        product: process.env.PRODUCT as string,
        ...params
    });

    const networkConfig = config.network?.InternalCustomerDataClient;
    const response = await fetchApi(url, { method: 'GET', headers }, networkConfig ? { networkConfig } : undefined);

    const contentType = response.headers.get('Content-Type');
    if (!response.ok || !contentType?.toLowerCase().includes('application/json')) {
        return { error: true, status: response.status };
    }

    try {
        return await response.json();
    } catch (error) {
        console.error(`Error fetching customer data: ${(error as Error).message}`);
        return { error: true };
    }
};

export const getEntryData = async (serverTime: string) => {
    return customerData(CustomerDataActions.ENTRY, { serverTime });
};
